import Phaser from 'phaser';

export default class Emitter {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,point, rate, lift) {
    this.scene = scene;
    this.pos = point;
    this.rate = rate;
    this.lift = lift || 100;
    this.emitProps = { position: new Phaser.Math.Vector2(), velocity: new Phaser.Math.Vector2() };

    this.minSpeed = 180;
    this.maxSpeed = 240;
    this.minLife = 40;
    this.maxLife = 141;
  }

  emitParticle () {
    const speed = Phaser.Math.Between(this.minSpeed,this.maxSpeed);
    const angle = Math.random() * 2 * Math.PI;
    this.emitProps.velocity.x = Math.cos(angle) * speed;
    this.emitProps.velocity.y = Math.sin(angle) * speed - this.lift;

    this.emitProps.velocity.x = (Math.random() - 0.5) * 240;
    this.emitProps.velocity.y = (Math.random() - 0.5) * 180 - this.lift;

    const xspread = 80;
    this.emitProps.position.x = this.pos.x + ((Math.random() - 0.5) * xspread);
    this.emitProps.position.y = this.pos.y;

    this.emitProps.lifetime = Phaser.Math.Between(this.minLife,this.maxLife) / 100;

    return this.emitProps;
  }
}